<template>
  <MandateEditorModal
    v-if="launcher.isOpen"
    :key="launcher.mandateId ?? 'new'"
    :mandateId="launcher.mandateId ?? null"
    @closed="onClosed"
  />
</template>

<script setup lang="ts">
import MandateEditorModal from "@/forwards2/mandates/MandateEditorModal.vue";
import { useMandateEditorLauncher } from "@/forwards2/mandates/useMandateEditorLauncher";
import { onBeforeUnmount } from "vue";

/**
 * Renders the mandate editor modal whenever `useMandateEditorLauncher` has a mandate open. Each page that
 * shows mandate links mounts one and reloads what it shows on `written`. Leaving the page closes the
 * editor, or the next page with a host would open on it — before the next page mounts, hence
 * `onBeforeUnmount`.
 */
const emit = defineEmits<{
  /** An editing session saved, archived, unarchived or deleted a mandate. */
  written: [];
}>();

const launcher = useMandateEditorLauncher();

const onClosed = (written: boolean) => {
  launcher.close();
  if (written) emit("written");
};

onBeforeUnmount(() => {
  if (launcher.isOpen) launcher.close();
});
</script>
